import { render } from "./DeleteRedSvg.vue?vue&type=template&id=305244f0"
import script from "./DeleteRedSvg.vue?vue&type=script&lang=js"
export * from "./DeleteRedSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__